import React from 'react'
// import { Block as CmsBlock } from '@corratech/cms-display/src/block';
import { arrayOf, string } from 'prop-types'
import { RichContent } from '@corratech/pylot-rich-content'
import { compactInlineStyles } from '../../utils'
import PageBuilderStyleTags from '../../PageBuilderStyleTags'

export const CmsBlock = ({ content, attributes }) => (
    <RichContent html={content} {...attributes} />
)

/**
 * Page Builder Block component.
 *
 * This component is part of the Page Builder / PWA integration. It can be consumed without Page Builder.
 *
 * @typedef Block
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a Block.
 */
const Block = (props) => {
    const {
        richContent,
        cssBlocks = [],
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
        cssClasses = []
    } = props

    const dynamicStyles = {
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft
    }

    return (
        <div
            style={compactInlineStyles(dynamicStyles)}
            className={cssClasses.join(' ')}
        >
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <PageBuilderStyleTags cssBlocks={cssBlocks} idPrefix="pb-block" />
            <CmsBlock content={richContent} attributes={props} />
            {/* <pre>
                { JSON.stringify(richContent) }
            </pre> */}
        </div>
    )
}

/**
 * Props for {@link Block}
 *
 * @typedef props
 *
 * @property {String} richContent Rich content of the block
 * @property {String} textAlign Alignment of the block within the parent container
 * @property {String} border CSS border property
 * @property {String} borderColor CSS border color property
 * @property {String} borderWidth CSS border width property
 * @property {String} borderRadius CSS border radius property
 * @property {String} marginTop CSS margin top property
 * @property {String} marginRight CSS margin right property
 * @property {String} marginBottom CSS margin bottom property
 * @property {String} marginLeft CSS margin left property
 * @property {String} paddingTop CSS padding top property
 * @property {String} paddingRight CSS padding right property
 * @property {String} paddingBottom CSS padding bottom property
 * @property {String} paddingLeft CSS padding left property
 * @property {Array} cssClasses List of CSS classes to be applied to the component
 */
Block.propTypes = {
    richContent: string,
    cssBlocks: arrayOf(string),
    textAlign: string,
    border: string,
    borderColor: string,
    borderWidth: string,
    borderRadius: string,
    marginTop: string,
    marginRight: string,
    marginBottom: string,
    marginLeft: string,
    paddingTop: string,
    paddingRight: string,
    paddingBottom: string,
    cssClasses: arrayOf(string)
}

export default Block
